// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3rg1M","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__29BL6"};